<div class="flex flex-col flex-col-reverse md:flex-row md:gap-8">
  <div class="md:w-[30%] w-full">
    <p class="md:text-3xl text-xl md:mb-12 mb-8 text-center mt-4">
      Welcome to our Partner Portal
    </p>
    <app-load-spinner-wrapper [loading]="loading">
      <p class="md:text-2xl text-xl mb-4 text-left mt-4">
        Reset Password
      </p>
      <p class="text-left mb-2">
        We have sent a password reset code in an email message. Enter your code and your new password.
      </p>
      <form [formGroup]="loginForm" (ngSubmit)="changePassword()" class="flex flex-col">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Code</mat-label>
          <input matInput formControlName="code" type="text" autocomplete="one-time-code">
          @if (loginForm.get('code')?.hasError('required')) {
            <mat-error>
              Code is required.
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full mb-5" [subscriptSizing]="'dynamic'">
          <mat-label>New Password</mat-label>
          <input matInput formControlName="password" type="password" autocomplete="new-password" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.\[\]{}()&quot;!@#%&amp;/\\,><':;|_~`+=-]).{10,}$">
          @if (loginForm.get('password')?.hasError('required')) {
            <mat-error>
              Password is required.
            </mat-error>
          }
          @if (loginForm.get('password')?.hasError('minlength')) {
            <mat-error>
              Password must be at least 10 characters long.
            </mat-error>
          }
          @if (loginForm.get('password')?.hasError('pattern')) {
            <mat-error>
              Min 10 chars, with upper, lower, number & symbol.
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Confirm Password</mat-label>
          <input matInput formControlName="confirmPassword" type="password" autocomplete="new-password">
          @if (loginForm.get('confirmPassword')?.hasError('required')) {
            <mat-error>
              Please reenter your new password.
            </mat-error>
          }
          @if (loginForm.get('confirmPassword')?.hasError('mismatch')) {
            <mat-error>
              Passwords must match.
            </mat-error>
          }
        </mat-form-field>

        <button
          mat-raised-button
          class="mt-4 !bg-green w-full mb-8"
          type="submit"
          [disabled]="loading || loginForm.invalid">
          <p class="md:text-lg text-base">Change Password</p>
        </button>
        <div class="flex w-full justify-between">
          <a [routerLink]="['/forgot-password']" class="text-blue-600 underline">Back</a>
          <div class="text-right">
            <span class="mr-1">Didn't get the code?</span>
            <a
              [attr.aria-disabled]="resendCodeAttempt"
              [class.cursor-pointer]="!resendCodeAttempt"
              [class.cursor-not-allowed]="resendCodeAttempt"
              [class.pointer-events-none]="resendCodeAttempt"
              (click)="resendCode()"
              class="text-blue-600 underline cursor-pointer">Resend
            </a>
          </div>
        </div>

      </form>
    </app-load-spinner-wrapper>
  </div>
  <div class="md:w-[70%] w-full">
    <img
      src="assets/images/partnerPortalLoginImage.png"
      alt="Partner Portal"
      class="w-full h-auto">
  </div>
</div>
